import { Config, Connector, CreateConnectorFn } from "wagmi";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { AuthParams } from "@shared/src/hooks/auth/types";
import { getEoaOrScaSigner } from "@shared/src/lib/auth";
import { ConnectMutateAsync, DisconnectMutateAsync } from "wagmi/query";
import { useHostStore } from "@shared/src/stores/useHostStore";

export async function handleWalletConnection(
  connector: Connector,
  connect: ConnectMutateAsync<Config, unknown>,
  disconnect: DisconnectMutateAsync<unknown>,
) {
  const authstore = useAuthStore.getState();
  const sdk = useHostStore.getState().sdk;

  let retries = 0;
  async function connectWithRetry(connector: Connector<CreateConnectorFn>) {
    try {
      const res = await connect({ connector });

      if (connector.id === "baseAccount" || connector.id === "coinbaseWalletSDK") {
        const chainId = sdk?.config.chains.find(c => c.name.toLowerCase().includes("base"))?.id;

        if (!chainId) {
          console.log("Base chain not found in SDK config", { sdk });
          throw new Error("Base chain not found in SDK config");
        }
        await connector?.switchChain?.({ chainId }).catch(e => {
          console.warn("Error switching chain while connecting", e);
        });
      }
      const provider = await connector.getProvider();

      console.log("wcc provider", { provider, res });
      return provider;
    } catch (error: any) {
      if (error?.message.includes("Connector already connected")) {
        console.log("walletconnect retrying", retries);
        if (retries >= 3) throw error;
        retries++;
        await disconnect({ connector });
        return connectWithRetry(connector);
      } else throw error;
    }
  }

  authstore.setWalletStatus("awaiting_confirmation", connector.name);
  try {
    const provider = await connectWithRetry(connector);
    if (!provider) {
      throw "Failed to get provider";
    }
    const sig = getEoaOrScaSigner("eoa", provider);
    if (!sig) throw "Failed to get signer";
    return sig;
  } catch (error: any) {
    authstore.setWalletStatus("error", connector.name);
    if (error.message?.includes("blocked")) {
      throw new Error("Please accept the connection request in your wallet");
    }
    throw error;
  }

  authstore.setWalletStatus("initial", connector.name);
  const rkDetails = connector.rkDetails as any;

  if (!rkDetails?.downloadUrls?.qrCode) {
    authstore.setWalletStatus("error", connector.name);
    throw new Error("QR code connection not supported for this wallet");
  }
}

export async function retryWalletConnection(walletName: string, authenticate: (params: AuthParams) => Promise<any>) {
  const authstore = useAuthStore.getState();
  authstore.setConnectionLink(null);

  try {
    authstore.setWalletStatus("initial", walletName);
    // if (!connector) {
    //   throw new Error("No wallet connector found");
    // }

    // if (connector) {
    //   authstore.setWalletStatus("awaiting_confirmation", connector.name);
    //   return await authenticate({
    //     type: "wallet",
    //     //TODO: Fix this type
    //     //  //@ts-expect-error will fix
    //     connector,
    //     connectorIcon: connector.imageUrl as string,
    //   });
    // }

    // authstore.setWalletStatus("initial", connector.name);
    // return await authenticate({
    //   type: "wallet",
    //   connector,
    //   connectorIcon: connector.imageUrl || "/images/wallet",
    // });
  } catch (error: any) {
    // console.error("Retry connection failed:", error);
    // authstore.setWalletStatus("error", connector.name);
    // throw error;
  }
}
